import { request } from '@/utils/request'

export const fields = [
    // not displaying this currently
    // {
    //     field: 'altman_score',
    //     title: 'Altman Score',
    //     explanation:
    //         'We flag companies based on the Z and Z” scores using two separate methods. First, if the company falls ' +
    //         'below the threshold identified as the distress zone, then we will indicate that with a “1” flag. Second, ' +
    //         'if the Z or Z” score decreases two consecutive years AND falls within the “grey zone”, then that will ' +
    //         'likewise be indicated by a Notable flag. The second flag is meant to catch cases where the Z-Score is ' +
    //         'not yet in the distress zone, but the decreasing Z-Score value indicates deteriorating financial health. ' +
    //         'Z is for manufacturing-type companies. Z"" is for non-manufacturing-type companies.',
    //     values: {
    //         1: 'If Z < 1.80 or Z” < 1.10 = 1\nOR\nZ < 3.00 or Z” < 2.60 AND decreases two consecutive years',
    //     },
    // },
    {
        field: 'aaer_respondent',
        title: 'Accounting and Auditing Enforcement Releases',
        explanation:
            'Indicates a company has appeared in the SEC\'s "Accounting and Auditing Enforcement Releases" database',
        values: {
            1: 'Company has appeared in database',
        },
    },
    {
        field: 'accounting_estimate_change',
        title: 'Accounting Estimate Change',
        explanation:
            'Indicates  the filer has disclosed a change in estimate (CAE) as defined in ASC 250-10-20 and as required by ' +
            'ASC 250-10-50-4 in an annual or quarterly filing. We assign severity based primarily on where the estimate, ' +
            'especially positive ones, affects the financial statement.',
        values: {
            1: 'Any other change',
            2: 'Change is positive',
            3:
                'Change is positive and not contracting accounting/percentage completion OR change is positive and inventory ' +
                'or allowance for doubtful accounts ',
        },
    },
    {
        field: 'audit_fees_change',
        title: 'Audit Fees Change',
        explanation: 'Indicates significant change in the amount of  audit fees.',
        values: {
            1:
                'Large accelerated filer: any change > +/- 20%\n' +
                'Accelerated filer: any change > +/- 25%\n' +
                'Non-accelerated filer: any change > +/- 30%',
        },
    },
    {
        field: 'audit_fees_outlier',
        title: 'Audit Fees Outlier',
        explanation:
            'Indicates a company’s audit fees are an outlier on the high end compared to a peer group (grouped by ' +
            'industry and market cap). Logic compares fees relative to assets and revenues and is based on a statistical ' +
            'box-and-fencing approach. It only applies to the audit opinion firm.',
        values: {
            1: 'Outlier',
        },
    },
    {
        field: 'auditor_change',
        title: 'Auditor Change',
        explanation: 'The filer has recently disclosed a change in Auditor.',
        values: {
            2: 'Without issues',
            3: 'With issues',
        },
    },
    {
        field: 'auditor_ratification',
        title: 'Auditor Ratification',
        explanation:
            'Indicates whether the company’s shareholders have voted in significant numbers against the ratification ' +
            'of the company’s auditor.',
        values: {
            1: '>5% vote against',
            2: '>50% vote against',
        },
    },
    {
        field: 'beneish_score',
        title: 'Beneish Score',
        explanation:
            'Following Beneish, indicates whenever a company’s M-Score exceeds the threshold of -1.78. This ' +
            'indicates that the company has a higher probability of manipulating earnings. (Note that, as with ' +
            'the Altman Z-Score, financial companies are excluded from the calculation.)',
        values: {
            1: 'M > -1.78',
        },
    },
    {
        field: 'benfords_law',
        title: "Benford's Law",
        explanation:
            'Indicates deviations from Benford’s Law in two ways. First, a flag will occur if the company’s ' +
            'financial statements deviate from the law in a statistically significant way. That is, using the ' +
            'Kolmogorov-Smirnov test, there will be a “1” flag if the KS Score is greater than the ' +
            'Critical Value with 95% confidence. Second, a “2” flag will occur if a company fails ' +
            'the KS test and the MAD Score increased in two consecutive years.',
        values: {
            1: 'KS Score exceeds the Critical Value',
            2: 'MAD score increases two consecutive years AND KS Score exceeds the Critical Value',
        },
    },
    {
        field: 'ceo_change',
        title: 'CEO Change',
        explanation: 'Indicates CEO Departure. Excludes interim positions.',
        values: {
            1: 'Without issues',
            3: 'With issues',
        },
    },
    {
        field: 'cfo_change',
        title: 'CFO Change',
        explanation: 'Indicates CFO Departure. Excludes interim positions.',
        values: {
            1: 'Without issues',
            3: 'With issues',
        },
    },
    {
        field: 'civil_rights_litigation',
        title: 'Civil Rights Litigation',
        explanation:
            'Indicates  whether a company has any open litigation pertaining to Civil Rights. ' +
            'Civil Rights cases include Disabilities (NOS 446), Civil Rights (NOS 440), and Fair Housing (NOS 443).',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'cybersecurity',
        title: 'Cybersecurity',
        values: {
            1: 'Company disclosed a cybersecurity event',
        },
    },
    {
        field: 'disclosure_complexity',
        title: 'Disclosure Complexity',
        explanation: 'Indicates there has been a Cybersecurity breach.',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'disclosure_controls',
        title: 'Disclosure Controls',
        explanation:
            'The filer has recently disclosed Disclosure Control Issues. Exclusions: Where effective and ' +
            'the only other deficiency/disclosure relates to DC - Acquisition, etc. integration and/or ' +
            'challenges noted, no flag is given.',
        values: {
            1: 'Effective and "Other deficiency/disclosure"',
            2: 'Ineffective but NOT Material Weakness',
            3: 'Material Weakness',
        },
    },
    {
        field: 'employment_labor_litigation',
        title: 'Employment/Labor Litigation',
        explanation:
            'Indicates  whether a company has any open litigation pertaining to Employment and Labors. Includes ' +
            'Civil Rights - Employment (NOS 442), Americans with Disabilities - Employment (NOS 445), Fair ' +
            'Labor Standards Act (NOS 710), and Labor Law.',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'engagement_partner_change',
        title: 'Engagment/Partner Change',
        explanation:
            'Indicates  there was a change in Engagement Partner (from the Form AP data) within the same audit firm.',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'environmental_litigation',
        title: 'Environmental Litigation',
        explanation:
            'Indicates  whether a company has any open litigation pertaining to Environmental issues. ' +
            'Includes Environmental Matters (NOS 893).',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'financial_restatement',
        title: 'Financial Restatement',
        explanation: 'The filer has recently disclosed a Financial Restatement.',
        values: {
            1: 'Technical restatement',
            2: 'Qualitative restatement',
            3: 'reissuance restatement, i.e., 8-K Item 4.02',
        },
    },
    {
        field: 'going_concern',
        title: 'Going Concern',
        explanation:
            "Indicates that the company's audit opinion expressed a substantial doubt about the " +
            "company's ability to continue as a going concern.",
        values: {
            3: 'Any',
        },
    },
    {
        field: 'illegal_activities_litigation',
        title: 'Illegal Activities Litigation',
        explanation:
            'Indicates open litigation pertaining to corrupt or illegal activities. Includes Foreign ' +
            'Corrupt Practices Act (FCPA), RICO (NOS 470), Whistleblower - Qui Tam (NOS 375) and Other ' +
            'Fraud (NOS 370).',
        values: {
            3: 'Any',
        },
    },
    {
        field: 'intellectual_property_litigation',
        title: 'Intellectual Property Litigation',
        explanation:
            'Indicates open cases of intellectual property litigation. Includes Patent (NOS 830) and Copyright ' +
            '(NOS 820). Note that this is only the case when the entire corporation is sued, as opposed to ' +
            'selected directors or other insiders.',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'internal_controls',
        title: 'Internal Controls',
        explanation:
            'The filer has recently disclosed weakness in Internal Control according to SOX 404 (either ' +
            'Management or Auditor assessment).',
        values: {
            3: 'Any',
        },
    },
    {
        field: 'late_filing',
        title: 'Late Filing',
        explanation:
            'The filer has recently filed a Non Timely (NT10K, NT10Q) filing.\n\n' +
            'Tier 1 Issues:\n' +
            'Discrepancies or errors\n' +
            'In negotiations - SEC, regulators, etc.\n' +
            'Inability to pay auditors or dispute\n' +
            'Restatement of financials pending\n' +
            'Investigation underway (internal, external, or SEC)\n' +
            'Internal Controls issue\n' +
            'Material weakness issue\n' +
            'Accounting issue (all issues with prefix "Z-")\n\n' +
            'Tier 2 Issues:\n' +
            'Consultation/correspondence with SEC about accounting matters\n' +
            'Going concern or financial difficulty\n',

        values: {
            1: 'Any other Late Filing',
            2: 'Late Filing has Tier 2 issues',
            3: 'Late Filing has Tier 1 Issues OR Actual Filing is more than 4 weeks late after the deadline',
        },
    },
    {
        field: 'material_impairment',
        title: 'Material Impairment',
        explanation: 'Indicates the company disclosed an impairment, based on XBRL tagging disclosures.',
        values: {
            2: 'Any',
        },
    },
    {
        field: 'non_audit_fees',
        title: 'Non-Audit Fees',
        explanation:
            'Indicates a company’s non-audit fees (excluding audit-related) are more than 25% of their total fees',
        values: {
            1: 'More than 25%',
            2: 'More than 50%',
        },
    },
    {
        field: 'period_adjustment',
        title: 'Period Adjustment',
        explanation:
            'Indicates an adjustment to correct immaterial errors from prior periods. Since the errors are ' +
            'immaterial, restatements and amended filings are not required.',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'pledged_securities',
        title: 'Pledged Securities',
        explanation: 'Indicates that any amount of securities are pledged.',
        values: {
            1: 'Any',
        },
    },
    {
        field: 'regulatory_litigation',
        title: 'Regulator Litigation',
        explanation: 'Indicates  whether a company has any open regulatory cases pertaining to securities issues.',
        values: {
            3: 'Any',
        },
    },
    {
        field: 'shareholder_action_litigation',
        title: 'Shareholder Litigation',
        explanation:
            'Indicates there is any open shareholder class action or derivative litigation for the company. ' +
            'Includes Federal suits classified as Class Action OR Derivative AND Securities Law (NOS 850), or ' +
            'Stockholders Suits (NOS 160).',
        values: {
            3: 'Any open',
        },
    },
    {
        field: 'shareholder_activism',
        title: 'Shareholder Activism',
        explanation:
            'Indicates whether there are any recent shareholder activism records that pertain to either concerns, ' +
            'control, or disputes.',
        values: {
            1: 'Issue is ‘concern’',
            2: 'Issue is ‘control’',
            3: 'Issue is ‘dispute’',
        },
    },
].map(f => {
    return {
        ...f,
        tooltip: `${f.explanation}\n${Object.keys(f.values).reduce((acc, k) => `${acc}\n${k}: ${f.values[k]}`, '')}`,
    }
})

export const TAG_TOOLTIPS = {
    'Auditor Issues': 'Auditor Issues - Has frequently changed auditors, with issues',
    'Bad Compliance Record':
        'Bad Compliance Record - Consistently displays poor disclosure controls and internal controls',
    'Low Quality Reporting':
        'Low Quality Reporting - Financial filings are frequently late or subject to restatement post filing',
}

export const OVERVIEW_TOOLTIPS = {
    'Low Concern': 'No critical F.L.A.G. (Financial, Legal, Audit & Governance) signals',
    Caution: 'Historical critical F.L.A.G. (Financial, Legal, Audit & Governance) signal(s)',
    Critical: 'Current critical F.L.A.G. (Financial, Legal, Audit & Governance) risk signal(s)',
}

export function getCompanyText(company) {
    if (company.symbol) {
        return `${company.name} (${company.symbol})`
    }

    return company.name
}

export const AuditRiskService = {
    get(executiveId) {
        return request.get(`/api/audit-risk/executives/${executiveId}`)
    },
}
